'use strict';

const gigyaPostAuth = require('./utils/gigyaPostAuth');

module.exports = function () {
	function isRegistrationCompletePage() {
		return document.querySelector('[data-tealium-registration-complete="true"]') !== null;
	}

	function getAuthOptions() {
		const $handle = $('#gigya-handle');
		const $page = $('.page');

		return {
			postUrl: $handle.data('action') || $page.data('gigyaAuth'),
			eventType: $handle.data('eventType') || 'login'
		};
	}

	function handleLogin(eventObj) {
		// First, before any early return or the post-auth redirect: social sign-up has no other registration hook.
		if (window.lavazzaGtm && window.lavazzaGtm.auth) {
			window.lavazzaGtm.auth.handleSocialRegistrationLogin(eventObj);
		}

		const response = eventObj.response || eventObj || {};
		const operation = (response.operation || eventObj.eventName || '').toLowerCase();

		if (operation.includes('register')) {
			return;
		}

		const authOptions = getAuthOptions();
		if (!authOptions.postUrl) {
			return;
		}

		// On the account activated page keep the user on the page: sync the session only.
		if (isRegistrationCompletePage()) {
			authOptions.skipRedirect = true;
		}

		gigyaPostAuth.postGigyaAuth(eventObj, authOptions);
	}

	function handleLogout() {
		const logoutUrl = $('.page').data('gigyaLogout');
		if (logoutUrl) {
			window.location.href = logoutUrl;
		}
	}

	function bindGigyaHandlers() {
		if (!window.gigya?.accounts) {
			return;
		}

		window.gigya.accounts.addEventHandlers({
			onLogin: handleLogin,
			onLogout: handleLogout
		});
	}

	// Close the browser Gigya session too, otherwise screensets keep showing the previous account
	$('body').on('click', '.account-quick-links__logout-link, .logout-cta', function (e) {
		const href = this.href;

		if (!window.gigya?.accounts) {
			return;
		}

		e.preventDefault();
		window.gigya.accounts.logout({
			callback: function () {
				window.location.href = href;
			}
		});
	});

	if (window.gigya?.accounts) {
		bindGigyaHandlers();
	} else {
		const previousReady = window.onGigyaServiceReady;
		window.onGigyaServiceReady = function () {
			if (typeof previousReady === 'function') {
				previousReady();
			}
			bindGigyaHandlers();
		};
	}
};
